import { modalBibliographySearchResultAuthorityStore } from '@/store'
import { ModalBibliographySearchResultAuthorityStoreInterface } from '@/store/ModalBibliographySearchResultAuthorityStore'

export class ModalBibliographySearchResultAuthorityService {
  public open(params: ModalBibliographySearchResultAuthorityStoreInterface) {
    modalBibliographySearchResultAuthorityStore.open(params)
  }

  public close() {
    modalBibliographySearchResultAuthorityStore.close()
  }
}
